const PRODUCT_IMAGES = [
  "/IMG_0959.PNG",
  "/IMG_0963.PNG",
  "/IMG_0964.PNG",
  "/IMG_0965.PNG",
  "/IMG_0966.PNG",
  "/IMG_0967.PNG",
  "/IMG_0968.PNG",
  "/IMG_0969.PNG",
  "/IMG_0970.PNG",
];

function IPhoneFrame({ src, alt }: { src: string; alt: string }) {
  return (
    <div className="flex-shrink-0 w-[200px] sm:w-[220px]">
      <div
        className="relative rounded-[2rem] border-[8px] border-foreground/90 bg-foreground/90 shadow-xl overflow-hidden mx-auto"
        style={{ boxShadow: "0 20px 40px -12px rgba(0,0,0,0.2), 0 0 0 1px rgba(0,0,0,0.05)" }}
      >
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-4 bg-foreground/90 rounded-b-xl z-10" aria-hidden />
        <div className="relative aspect-[9/19] min-h-[380px] bg-background overflow-hidden">
          <img
            src={src}
            alt={alt}
            className="absolute inset-0 w-full h-full object-cover object-top"
            onError={(e) => {
              const t = e.target as HTMLImageElement;
              t.style.display = "none";
            }}
          />
        </div>
      </div>
    </div>
  );
}

export function ProductPhoneMarquee() {
  const duplicated = [...PRODUCT_IMAGES, ...PRODUCT_IMAGES];

  return (
    <div className="relative overflow-hidden marquee-pause">
      <div
        className="marquee-inner flex gap-8 w-max py-4"
        style={{ animationDuration: "90s" }}
      >
        {duplicated.map((src, i) => (
          <IPhoneFrame
            key={`${src}-${i}`}
            src={src}
            alt={`Buukd app screenshot ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
